import React, { createContext, useContext, useEffect, useState } from 'react'
import QrScanner from "react-qr-scanner";
import { UiItemContext } from '../../../cnr/contexts/UiItemContext'
import FullPageWrapper from '../../../wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper'

export const QrScanContext = createContext();

const QrScan = (props) => {

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_handlers } = uiItemContext ?? {}

  const [scannedData, setScannedData] = useState()
  const [active, setActive] = useState(true)

  console.log('props', props)

  const handleCancel = () => {
    setActive(false) // 👈 turns camera off
    if (props.handleCancel) {
      props.handleCancel()
    } else if (item_handlers.handleShow_itemSidebar) {
      item_handlers.handleShow_itemSidebar()
    }
  }

  const handleError = (err) => {
    console.log('e', err)
    console.error(err)
  }

  const handleScan = (_scannedData) => {
    if (!_scannedData) return;
    const text = _scannedData?.text;
    if (!text) return;

    setActive(false) // 👈 turns camera off

    console.log('text', text)

    try {
      // Try to decode if it’s base64-encoded JSON
      const parsed = JSON.parse(atob(text));
      setScannedData(parsed);
      props.handleScannedData?.(parsed);
    } catch {
      try {
        // Or maybe it was plain JSON
        const parsed = JSON.parse(text);
        setScannedData(parsed);
        props.handleScannedData?.(parsed);
      } catch {
        const decoded = JSON.parse(atob(text));
        console.log('decoded', decoded)
        // Otherwise, just return raw text
        setScannedData({ rawText: text });
        props.handleScannedData?.({ rawText: text });
      }
    }
  }

  // useEffect(() => {
  //   console.log('Starting camera test')

  //   const promise = navigator.mediaDevices?.getUserMedia({
  //     video: true
  //   })

  //   console.log('Promise', promise)

  //   promise
  //     ?.then((stream) => {
  //       console.log('SUCCESS', stream)
  //     })
  //     .catch((err) => {
  //       console.error('FAIL', err)
  //     })

  //   setTimeout(() => {
  //     console.log('5 seconds elapsed')
  //   }, 5000)
  // }, [])

  const qrReader = () => {
    const previewStyle = { width: "100%", };
    return (
      <QrScanner
        delay={300}                     // same as your old delay
        style={previewStyle}            // styling
        onError={handleError}           // handle errors
        onScan={handleScan}             // handle successful scans 
        constraints={{
          video: { facingMode: 'environment' }, // 👈 forces rear camera
        }}
        className="test"
      />
    );
  };

  const content = () => {
    if (scannedData) {
      return <QrScanContext.Provider value={{ qrScan_state: { scannedData: scannedData } }} >
        <div>{JSON.stringify(scannedData)}</div>
      </QrScanContext.Provider >
    } else if (active) {
      return qrReader(128)
    } else {
      return <div>---</div>
    }
  }

  const wrapper = () => <Wrapper
    content={content()}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'qr-container scan' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={props?.caption || 'QR Scan'}
    topperCaption2={props?.subCaption}
    wrapperCss={{ container: 'app-dark-mode' }}
  />

  return fullPageWrapper()
}

export default QrScan